import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-excel-large',
  templateUrl: './icon-excel-large.component.html',
  styleUrls: ['./icon-excel-large.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconExcelLargeComponent {}
